import React from 'react';
import GenericCourseIntro from '../../../components/course/GenericCourseIntro';

// Import de la structure du cours
import { courseStructure } from './course-structure';

// Contenu d'introduction
import IntroductionContent from './chapitres/IntroductionContent';

const Template = () => {
  return (
    <GenericCourseIntro
      courseStructure={courseStructure}
      IntroductionContent={IntroductionContent}
    />
  );
};

export default Template; 